import { InjectionToken } from '@angular/core';

export type ApplicationType = 'desktop' | 'mobile';
export const APPLICATION_TYPE = new InjectionToken<ApplicationType>('APPLICATION_TYPE');
